import type { EditableText } from './types';
import { layoutMaipoText } from '@maipo/format';

export interface TextLayoutLine {
  text: string;
  x: number;
  y: number;
  width: number;
}

export interface TextLayout {
  lines: readonly TextLayoutLine[];
  width: number;
  height: number;
  contentHeight: number;
  overflow: boolean;
  lineHeight: number;
  lineCount: number;
  horizontalOverflow: boolean;
  verticalOverflow: boolean;
}

export interface TextMeasurer {
  measure(text: string, textStyle: EditableText['style']): number;
}

const approximateMeasurer: TextMeasurer = {
  measure(text, style) {
    let units = 0;
    for (const character of text) units += /[MW@#%]/.test(character) ? 0.9 : /[il.,' ]/.test(character) ? 0.3 : 0.58;
    return units * style.size;
  },
};

export function layoutText(source: EditableText, measurer: TextMeasurer = approximateMeasurer): TextLayout {
  if (source.schemaVersion === 2) throw new Error('Portable text requires its verified metric layout.');
  return layoutMaipoText({
    text: source.value,
    frame: { width: source.box.width, height: source.box.height, autoHeight: source.box.autoHeight },
    style: {
      fontFamily: source.style.family,
      fontWeight: source.style.weight,
      fontSize: source.style.size,
      lineHeight: source.style.lineHeight,
      letterSpacing: source.style.tracking,
      textAlign: source.style.align,
      color: source.style.color,
    },
  }, { measure: (text) => measurer.measure(text, source.style) });
}

export function textLayoutBounds(source: EditableText): { x: number; y: number; width: number; height: number } {
  if (source.schemaVersion === 2) return { x: 0, y: 0, width: source.box.width, height: source.box.height };
  const layout = layoutText(source);
  return { x: 0, y: 0, width: layout.width, height: layout.height };
}
